// extracted by mini-css-extract-plugin
export default {"transaction__controls":"TransactionControls_transaction__controls__ilnj3"};